import { AuthResponse, LoginCredentials } from "@/types";
import { useMutation } from "@tanstack/react-query";
import { useQueryClient } from "@tanstack/react-query";
import { httpRequest } from "@/lib";

export async function authenticate(
  request: LoginCredentials
): Promise<AuthResponse> {
  // The shared client owns the base URL, the tenant header and the retry and
  // refresh interceptors. This used to mutate the global axios defaults
  // instead, so it inherited none of them — and when VITE_API_URL was absent
  // from the build it posted to the page origin, where nginx answers 405.
  const response = await httpRequest.post<AuthResponse>("/login", request);
  return response.data;
}

export function useAuthenticationMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: authenticate,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["login"] });
    },
  });
}
